<app-header></app-header>

<div class="rotate-img">
  <img id="loadinfIf" src="../../assets/video/rotatee.gif" alt="" />
  <span id="opacity" class="absoluteOpacity"></span>
</div>

<ng-container *ngIf="permissions?.length; else noPermissions">
  <ng-container *ngIf="reportsData">
    <swiper [config]="config" [virtual]="true" class="my-swiper">
      <ng-template swiperSlide *ngIf="brands.length">

        <div class="cards swiper-slide-container">
          <mat-form-field appearance="fill">
            <mat-label>Brand</mat-label>
            <mat-select (selectionChange)="onChangeValue($event, 'brand')" [value]="selectedBrand">
              <mat-option *ngFor="let item of brands | orderBy:'brand'" [value]="item.brand">
                {{ item.brand }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </ng-template>
      <ng-template swiperSlide *ngIf="isAccessAvailable('country')">
        <div class="cards swiper-slide-container">
          <mat-form-field appearance="fill" *ngIf="isAccessAvailable('country')">
            <mat-label>Country</mat-label>
            <mat-select (selectionChange)="onChangeValue($event, 'country')" [value]="selectedCountry">
              <mat-option *ngFor="let item of getDataLists('country')" [value]="item">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-template>
      <ng-template swiperSlide *ngIf="isAccessAvailable('state')">
        <div class="cards swiper-slide-container">
          <mat-form-field appearance="fill" *ngIf="isAccessAvailable('state')">
            <mat-label>State</mat-label>
            <mat-select (selectionChange)="onChangeValue($event, 'state')" [value]="selectedState">
              <mat-option *ngFor="let item of getDataLists('state')" [value]="item">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-template>
      <ng-template swiperSlide *ngIf="isAccessAvailable('area')">
        <div class="cards swiper-slide-container">
          <mat-form-field appearance="fill">
            <mat-label>Area</mat-label>
            <mat-select (selectionChange)="onChangeValue($event, 'area')" [value]="selectedArea">
              <mat-option *ngFor="let item of getDataLists('area')" [value]="item">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-template>
      <ng-template swiperSlide *ngIf="isAccessAvailable('cluster')">
        <div class="cards swiper-slide-container">
          <mat-form-field appearance="fill">
            <mat-label>Cluster</mat-label>
            <mat-select (selectionChange)="onChangeValue($event, 'cluster')" [value]="selectedCluster">
              <mat-option *ngFor="let item of getDataLists('cluster')" [value]="item">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-template>
      <ng-template swiperSlide *ngIf="isAccessAvailable('store')">
        <div class="cards swiper-slide-container">
          <mat-form-field appearance="fill">
            <mat-label>Store</mat-label>
            <mat-select (selectionChange)="onChangeValue($event, 'store')" [value]="selectedStore">
              <mat-option *ngFor="let item of getDataLists('store')" [value]="item">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-template>

      <ng-template swiperSlide *ngIf="reportsData?.programs">
        <div class="cards swiper-slide-container">
          <mat-form-field appearance="fill">
            <mat-label>Programs</mat-label>
            <mat-select (selectionChange)="onChangeProgram($event)" [value]="selectedProgram">
              <mat-option *ngFor="let item of getPrograms() | orderBy:'name'" [value]="item.name">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-template>

      <ng-template swiperSlide>
        <div class="cards swiper-slide-container">
          <div class="svg" (click)="ExportTOExcel()">
            <span>Download</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download"
              viewBox="0 0 16 16">
              <path
                d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path
                d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg>
          </div>
        </div>
      </ng-template>
    </swiper>

    <!-- graphs -->

    <div class="graphs">
      <div class="graph">
        <canvas baseChart height="200px" width="400px" [labels]="progressChartData.labels"
          [datasets]="progressChartData.datasets" [options]="barChartOptions" [legend]="barChartLegend" [type]="'bar'">
        </canvas>
      </div>

      <div class="graph">
        <canvas baseChart height="200px" width="400px" [labels]="scoreChartData.labels"
          [datasets]="scoreChartData.datasets" [options]="barChartOptions" [legend]="barChartLegend" [type]="'bar'">
        </canvas>
      </div>
    </div>

    <ng-container>
      <div #TABLE>
        <table #table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
          class="mat-elevation-z8 demo-table" matSortDisableClear>
          <ng-container matColumnDef="brand">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hide-arrow">
              Brand
            </th>
            <td mat-cell *matCellDef="let element">{{ element.brand }}</td>
          </ng-container>

          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hide-arrow">
              Store
            </th>
            <td mat-cell *matCellDef="let element">{{ element.location }}</td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hide-arrow">
              Name
            </th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>

          <ng-container matColumnDef="programName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hide-arrow">
              program
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.programName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hide-arrow">
              started
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.startDate | date: "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="completedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hide-arrow">
              completed
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.completedDate }}
            </td>
          </ng-container>

          <ng-container matColumnDef="completionPercent">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hide-arrow">
              Progress
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.completionPercent }} %
            </td>
          </ng-container>

          <ng-container matColumnDef="scorePercent">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hide-arrow">
              Score
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.scorePercent }} %
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </ng-container>
  </ng-container>

</ng-container>





<ng-template #noPermissions>
  <p style="margin: 20px">No Reports available.</p>
</ng-template>
